import React from 'react';

export function PastState(props: { selectedData: any }) {
  return (
    <div className='h-[60vh] lg:h-[65vh] flex flex-col justify-center items-center gap-20 rounded-md'>
      <img src={props.selectedData} alt={'....'} className='h-[60vh] lg:h-[65vh] rounded-md' />
    </div>
  );
}
